export default "__VITE_ASSET__tS0sP9fY__"